import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { policyComplianceDefaultFilter } from '../../../../../views/Policies/PolicyComplianceDashboard/utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policy-compliance/')({
  validateSearch: zodValidator(withDefaults(schema.POLICY_COMPLIANCE, defaultFilter, policyComplianceDefaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
